import getFullSearchHistoryFromRestOperation from 'owa-service/lib/operation/getFullSearchHistoryFromRestOperation';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import strings from 'owa-strings/owa-options-strings';
import { action, orchestrator } from 'satcheljs';
import { getUserConfiguration } from 'owa-session-store';

interface ExportSearchHistoryActionMessage {
    userConfig: OwaUserConfiguration;
}

let exportSearchHistory = action(
    'exportSearchHistory',
    (): ExportSearchHistoryActionMessage => {
        return { userConfig: getUserConfiguration() };
    }
);

orchestrator(exportSearchHistory, actionMessage => {
    // Get the REST search history, merge it with the client search
    // history, and export the merged histories
    getFullSearchHistoryFromRestOperation({}).then(result => {
        let suggestions = result.Response ? result.Response.value : [];
        let suggestionTexts = suggestions.map(e => e.SuggestedQuery);

        var blob = new Blob(
            [
                suggestionTexts.join('\n'),
                actionMessage.userConfig.ViewStateConfiguration.SearchHistory.join('\n'),
            ],
            { type: 'text/plain' }
        );
        const FileSaver = require('file-saver');
        FileSaver.saveAs(blob, `${strings.option_privacy_searchHistory_file_name}.csv`);
    });
});

export default exportSearchHistory;
export { ExportSearchHistoryActionMessage };
